import { type ReactNode } from 'react';
import { EmptyState } from '@/components/ui/empty-state';
import type { EnrichedMember } from '../types';
import { ApproacherRow } from './approacher-row';
import { ApproacherListHeader } from './approacher-list-header';
import { ApproacherTableSkeleton } from './approacher-table-skeleton';

type Props = {
  data: EnrichedMember[] | undefined;
  showSkeleton: boolean;
  onSelect: (id: string) => void;
};

function TableBody({
  data,
  onSelect,
}: {
  data: EnrichedMember[];
  onSelect: (id: string) => void;
}): ReactNode {
  return (
    <tbody>
      {data.map((a) => (
        <ApproacherRow key={a.id} member={a} onClick={() => onSelect(a.id)} />
      ))}
    </tbody>
  );
}

export function ApproacherList({
  data,
  showSkeleton,
  onSelect,
}: Props): ReactNode {
  if (!showSkeleton && !data?.length)
    return <EmptyState title="Sin miembros" />;
  return (
    <div className="overflow-hidden rounded-xl bg-white/[0.02]">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[760px] text-left">
          <ApproacherListHeader />
          {showSkeleton ? (
            <ApproacherTableSkeleton />
          ) : (
            data && <TableBody data={data} onSelect={onSelect} />
          )}
        </table>
      </div>
    </div>
  );
}
